


















import { defineComponent, PropType } from '@vue/composition-api'
import { CatalogItem } from '@/store/socialStream/postApiRequestHelper'
import PostRow from '@/views/components/socialStream/PostRow.vue'
import ProductsFromCatalogStore from '@/store/productsList/productsFromCatalog'
import PaginationPostList from '@/views/components/socialStream/PaginationPostList.vue'

export default defineComponent({
  name: 'PostsByRowList',
  components: { PaginationPostList, PostRow },
  computed: {
    postsToDisplay() {
      return ProductsFromCatalogStore.state.productsList as Array<CatalogItem>
    },
    postsList(): any {
      return this.posts
    },
  },
})
